import React, { useState } from 'react';
import Modal from 'react-modal';
import '../../components/popup/Popup.css'
import RegistrationForm from '../../components/popup/RegistrationForm';

function RegisterPopup(props) {
  const [isOpen, setIsOpen] = useState(false);


  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <div >
      <button onClick={openModal} className={props.className}>{props.button}</button>
      <Modal isOpen={isOpen} onRequestClose={closeModal} className='popupContainer'>
        <h2>{props.title}</h2>
       <RegistrationForm className='imageInputRegister'/>
        {/* <button onClick={closeModal}>Close Modal</button> */}
      </Modal>
    </div>
  );
}

export default RegisterPopup
